import { render, staticRenderFns } from "./StatueImageAndContent.vue?vue&type=template&id=b88dbda6&scoped=true"
import script from "./StatueImageAndContent.vue?vue&type=script&lang=ts"
export * from "./StatueImageAndContent.vue?vue&type=script&lang=ts"
import style0 from "./StatueImageAndContent.vue?vue&type=style&index=0&id=b88dbda6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88dbda6",
  null
  
)

export default component.exports